import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Treatments',
    href: '/#treatments'
  }, {
    name: 'About',
    href: '/#about'
  }, {
    name: 'Contact',
    href: '/contact'
  }, {
    name: 'Privacy Policy',
    href: '/privacy-policy'
  }, {
    name: 'Terms & Conditions',
    href: '/terms-conditions'
  }, {
    name: 'SMS Terms',
    href: '/sms-terms'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('/#')) {
      const targetId = href.replace('/#', '');
      if (location.pathname !== '/') {
        // Let the router handle it if not on home page
        return;
      }
      e.preventDefault();
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
        setMobileMenuOpen(false);
      }
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${isScrolled ? 'bg-brand-black/90 backdrop-blur-md border-brand-gold/20 py-4 shadow-gold-sm' : 'bg-brand-black border-transparent py-6'}`} data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="flex justify-between items-center" data-id="element-217">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 z-50" data-id="element-218">
            <span className="font-heading text-2xl md:text-3xl font-semibold text-brand-gold tracking-wide" data-id="element-219">
              Deluxe MedSpa Beauty
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-220">
            {navLinks.map(link => <Link key={link.name} to={link.href} onClick={e => handleNavClick(e, link.href)} className="text-sm font-medium text-brand-champagne-light hover:text-brand-gold transition-colors duration-200" data-id="element-221">
                {link.name}
              </Link>)}
            <Link to="/#appointment" onClick={e => handleNavClick(e, '/#appointment')} className="inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-sm text-brand-black bg-brand-gold hover:bg-brand-gold-light transition-colors duration-300 shadow-gold-glow" data-id="element-222">
              Book Consultation
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center z-50" data-id="element-223">
            <button type="button" className="text-brand-gold hover:text-brand-gold-light p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-expanded={mobileMenuOpen} data-id="element-224">
              <span className="sr-only" data-id="element-225">Open main menu</span>
              {mobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-226" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-227" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden fixed inset-0 z-40 bg-brand-black transition-transform duration-300 ease-in-out ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-228">
        <div className="pt-24 pb-6 px-4 space-y-6 flex flex-col h-full overflow-y-auto" data-id="element-229">
          {navLinks.map(link => <Link key={link.name} to={link.href} onClick={e => handleNavClick(e, link.href)} className="block text-xl font-heading text-brand-champagne-light hover:text-brand-gold border-b border-brand-charcoal pb-4" data-id="element-230">
              {link.name}
            </Link>)}
          <div className="pt-6 mt-auto" data-id="element-231">
            <Link to="/#appointment" onClick={e => handleNavClick(e, '/#appointment')} className="w-full flex items-center justify-center px-6 py-4 border border-transparent text-base font-medium rounded-sm text-brand-black bg-brand-gold hover:bg-brand-gold-light transition-colors duration-300" data-id="element-232">
              Book Consultation
            </Link>
          </div>
        </div>
      </div>
    </header>;
}